(function(){
  function initGate(){
    var picker = document.querySelector('variant-picker');
    var formComponent = document.querySelector('product-form-component');
    if(!picker || !formComponent) return;

    var form = formComponent.querySelector('form[data-type="add-to-cart-form"]');
    if(!form) return;
    var hiddenIdInput = form.querySelector('input[name="id"]');
    var buttonsWrap = formComponent.querySelector('.product-form-buttons');
    if(!hiddenIdInput || !buttonsWrap) return;

    var selects = picker.querySelectorAll('.variant-option__select');
    var sizeSelect = null;
    selects.forEach(function(s){
      if(s.name.toLowerCase().indexOf('size') !== -1) sizeSelect = s;
    });
    if(!sizeSelect) return; // no real Size option on this product — nothing to gate

    // Insert a neutral placeholder and clear the native pre-selection.
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select your size';
    sizeSelect.insertBefore(placeholder, sizeSelect.firstChild);
    Array.prototype.forEach.call(sizeSelect.querySelectorAll('option[selected]'), function(o){
      if(o !== placeholder) o.removeAttribute('selected');
    });
    sizeSelect.value = '';
    hiddenIdInput.value = '';

    var chosen = false;

    var msg = document.createElement('div');
    msg.className = 'cj-size-required-msg';
    msg.textContent = 'Please select your ring size.';
    msg.hidden = true;
    var wrapperEl = sizeSelect.closest('.variant-option--dropdowns') || sizeSelect.parentElement;
    wrapperEl.parentElement.insertBefore(msg, wrapperEl.nextSibling);

    sizeSelect.addEventListener('change', function(){
      if(sizeSelect.value !== ''){
        chosen = true;
        msg.hidden = true;
        var opt = sizeSelect.options[sizeSelect.selectedIndex];
        var vid = opt.getAttribute('data-variant-id');
        if(vid) hiddenIdInput.value = vid;
      } else {
        chosen = false;
        hiddenIdInput.value = '';
      }
    });

    buttonsWrap.addEventListener('click', function(e){
      if(!chosen){
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        msg.hidden = false;
      }
    }, true);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initGate);
  } else {
    initGate();
  }
})();
